import { render, staticRenderFns } from "./Dialog_StoreHeadTeacher.vue?vue&type=template&id=3a249f42&scoped=true&"
import script from "./Dialog_StoreHeadTeacher.vue?vue&type=script&lang=js&"
export * from "./Dialog_StoreHeadTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a249f42",
  null
  
)

export default component.exports